var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('li',{staticClass:"pt-8 pb-2 pl-4 pr-4 text-left font-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }